import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import AppHelmetProvider from './components/HelmetProvider'
import ErrorBoundary from './components/ErrorBoundary'

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary>
      <AppHelmetProvider>
        <App />
      </AppHelmetProvider>
    </ErrorBoundary>
  </StrictMode>,
)